// extracted by mini-css-extract-plugin
module.exports =  {"editor":"rich_text-module_editor_efa22","label":"rich_text-module_label_f0526"};